import { Store } from "pullstate";
import api from "../services/api";
import logger from "../services/logger";

const initialState = {
    content: null,
    generatedAt: null,
    loading: false,
    error: null,
    timedOut: false,
};

export const ClientSummaryStore = new Store(initialState);

let pollTimer = null;
let pollAbortController = null;

export const fetchClientSummary = async (clientId, abortController) => {
    const controller = abortController || new AbortController();
    try {
        const result = await api.get(`/api/clients/${clientId}/summary`, null, { signal: controller.signal });
        if (result) {
            ClientSummaryStore.update((s) => {
                s.content = result.content;
                s.generatedAt = result.generatedAt;
            });
        }
    } catch (e) {
        if (!api.requestWasCanceled(e)) {
            logger.error("Failed to fetch client summary", e);
        }
    }
    return controller;
};

export const generateClientSummary = async (clientId) => {
    if (pollTimer) {
        clearInterval(pollTimer);
        pollTimer = null;
    }
    if (pollAbortController) {
        pollAbortController.abort();
        pollAbortController = null;
    }

    ClientSummaryStore.update((s) => {
        s.loading = true;
        s.error = null;
        s.timedOut = false;
    });

    try {
        await api.post(`/api/clients/${clientId}/summary/generate`, {});
    } catch (e) {
        logger.error("Failed to trigger summary generation", e);
        ClientSummaryStore.update((s) => {
            s.loading = false;
            s.error = "Failed to start generation.";
        });
        return;
    }

    let elapsed = 0;
    pollTimer = setInterval(async () => {
        elapsed += 3000;
        if (elapsed >= 60000) {
            clearInterval(pollTimer);
            pollTimer = null;
            ClientSummaryStore.update((s) => {
                s.loading = false;
                s.timedOut = true;
            });
            return;
        }
        if (pollAbortController) pollAbortController.abort();
        pollAbortController = new AbortController();
        try {
            const result = await api.get(`/api/clients/${clientId}/summary`, null, { signal: pollAbortController.signal });
            if (result?.content) {
                clearInterval(pollTimer);
                pollTimer = null;
                ClientSummaryStore.update((s) => {
                    s.loading = false;
                    s.content = result.content;
                    s.generatedAt = result.generatedAt;
                });
            }
        } catch (e) {
            if (!api.requestWasCanceled(e)) {
                logger.error("Poll error for client summary", e);
            }
        }
    }, 3000);
};

export const resetClientSummary = () => {
    if (pollTimer) {
        clearInterval(pollTimer);
        pollTimer = null;
    }
    if (pollAbortController) {
        pollAbortController.abort();
        pollAbortController = null;
    }
    ClientSummaryStore.update(() => ({ ...initialState }));
};
